import { render, staticRenderFns } from "./small.vue?vue&type=template&id=271c226e&scoped=true&"
import script from "./small.vue?vue&type=script&lang=js&"
export * from "./small.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271c226e",
  null
  
)

export default component.exports